// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__AG9LS"};